'use client';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ContactInformationProps } from './types';
import Button from '@mui/material/Button';
import Link from 'next/link';

interface props {
  contactInformation: ContactInformationProps;
  top?: boolean;
}

const ContactInformation = ({ contactInformation, top }: props) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: top ? '1px solid' : '',
      borderColor: top ? 'divider' : '',
    }}
  >
    <Typography variant='h5' sx={{ fontWeight: 'bold' }}>
      {contactInformation.title}
    </Typography>

    <Button
      LinkComponent={Link}
      href={top ? `tel:${contactInformation.value}` : `mailto:${contactInformation.value}`}
      variant='text'
      color='secondary'
      sx={{
        fontSize: '20px',
        '&:hover': {
          boxShadow: 0,
          backgroundColor: 'transparent',
        },
      }}
    >
      {contactInformation.value}
    </Button>
  </Box>
);

export default ContactInformation;
